import { render } from "./userCenterMenu.vue?vue&type=template&id=96de562a&scoped=true"
import script from "./userCenterMenu.vue?vue&type=script&lang=js"
export * from "./userCenterMenu.vue?vue&type=script&lang=js"

import "./userCenterMenu.vue?vue&type=style&index=0&id=96de562a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96de562a"]])

export default __exports__